import React, { memo,  useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../rmsReduxStore/rmsReduxHooks';

import { cloneDeep } from 'lodash';
import { updateMasterInfo, useEffectOnce } from '../../../../globalUtils/globalHooks';
import ParametersTable from '../../../../globalUtils/ParametersTable/ParametersTable';

import { useLocation } from 'react-router-dom';
import { getAcChargerReducer } from '../../../rmsReduxStore/acReduxExports';
import { fetchAcChargerMasterInfo, fetchAcChargerSystemInfo } from '../../../rmsReduxStore/acChargersRedux/acChargerCreators';

interface ChargerPanelSystemsInfo {
  contentHeight: number
}

const AcChargerPanelSystemsInfoDashboard = memo(function ChargerPanelSystemsInfoDashboard({ contentHeight }: ChargerPanelSystemsInfo) {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { chargerMasterInfo, chargerSystemInfo } = useAppSelector(getAcChargerReducer);
  const [systemInfoData, setSystemInfoData] = useState<ChargerMasterInfo[] | null>(null);


  useEffect(() => {
    if (chargerMasterInfo !== null && chargerSystemInfo !== null) {
      const chargerMasterData = cloneDeep(chargerMasterInfo);
      const chargerSystemData = cloneDeep(chargerSystemInfo);
      const data = updateMasterInfo(chargerMasterData, chargerSystemData);
      setSystemInfoData(data)
    }
  }, [chargerMasterInfo, chargerSystemInfo])

  useEffectOnce(() => {
    dispatch(fetchAcChargerMasterInfo({ chargerId: location?.state?.chargerId }))
    dispatch(fetchAcChargerSystemInfo({ chargerId: location?.state?.chargerId }))
  })

  return (
    <div className="charger__panel__systems__info__dashboard" style={{ height: `${contentHeight}px` }}>
<ParametersTable data={systemInfoData} containerClassName={'charger__panel__systems__info-paramters-table'} />
    </div>
  )
}
)

export default AcChargerPanelSystemsInfoDashboard
